module.exports = __webpack_public_path__ + "img/thumbnail_size-big.e3b310a8.svg";